import React, { useEffect, useState } from "react";

import {
  CButton,
  CCard,
  CCardHeader,
  CCol,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CRow,
  CSpinner
} from "@coreui/react";
import { RiCheckDoubleFill } from "react-icons/ri";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import { logout } from "../../../../../actions/baseActions";
import { setObj } from "../../../../../actions/noteActions";
import Breadcrumb from "../../../../../components/Breadcrumb";
import Loading from "../../../../../components/Loading";
import ProtectedRoute from "../../../../../components/ProtectedRoute";
import SelectFilter from "../../../../../components/SelectFilter";
import URL from "../../../../../config/api";
import axios from "../../../../../config/axios";

const PartialProgressionAllocateByTrail = props => {
  const [loading, setLoading] = useState(true);
  const [trails, setTrails] = useState([]);

  const [trailInAction, setTrailInAction] = useState();
  const [showModal, setShowModal] = useState(false);
  const [trailToDelete, setTrailToDelete] = useState();

  const [serieList, setSerieList] = useState();
  const [serie, setSerie] = useState(0);

  const [classRoomList, setClassRoomList] = useState();
  const [classRoom, setClassRoom] = useState();
  const userID = props.match.params.id;
  const [userName, setUserName] = useState();

  useEffect(() => {
    (async () => {
      try {
        const serieListResponse = await axios.get(
          `${URL.api}classification/serie/list`,
          { headers: { Authorization: `Bearer ${props.user.token}` } }
        );
        const classRoomListReponse = await axios.get(
          `${URL.api}community/room/list?class=true&school[]=${props.general.active_roles.school_id}`,
          { headers: { Authorization: `Bearer ${props.user.token}` } }
        );

        const serieList = serieListResponse.data.data.map(serie => ({
          label: serie.name,
          value: serie.id
        }));

        const classRoomList = classRoomListReponse.data.data.map(classroom => ({
          label: classroom.name,
          value: classroom.id
        }));

        setClassRoomList(classRoomList);
        setSerieList(serieList);

        const trailListResponse = await axios.get(
          `${URL.api}activity/trail/public`,
          {
            headers: { authorization: `Bearer ${props.user.token}` }
          }
        );
        const allocationListResponse = await axios.get(
          `${URL.api}activity/trail_allocation/partial_progression/listByUser/${userID}`,
          {
            headers: {
              Authorization: `Bearer ${props.user.token}`
            }
          }
        );
        const userResponse = await axios.get(
          `${URL.api}access/user/singleView/${userID}`,
          {
            headers: { Authorization: `Bearer ${props.user.token}` }
          }
        );

        const trailList = trailListResponse.data.data.map(trail => {
          let auxTrail = { ...trail, allocation_id: 0 };
          allocationListResponse.data.data.map(allocation => {
            if (allocation.trail_id === trail.id) {
              auxTrail.allocation_id = allocation.trail_allocation_id;
            }
          });
          return auxTrail;
        });

        setTrails(trailList);
        setUserName(userResponse.data.data.user?.name);
      } catch {
        toastr.error("Erro!", "Não foi possivel acessar dados necessários");
      }
      setLoading(false);
    })();
  }, []);

  const createAllocation = async trailId => {
    const allocationResponse = await axios.post(
      `${URL.api}activity/trail_allocation/partial_progression/insert`,
      {
        trail_id: trailId,
        user_id: userID,
        allocator_user_id: props.user.user.id
      },
      {
        headers: {
          Authorization: `Bearer ${props.user.token}`
        }
      }
    );
    const updatedTrailList = trails.map(trail => {
      let auxTrail = trail;
      if (trail.id === trailId) {
        auxTrail.allocation_id = allocationResponse.data.data;
      }
      return auxTrail;
    });
    setTrails(updatedTrailList);
    setTrailInAction(null);
  };

  const deleteAllocation = async () => {
    setTrailInAction(trailToDelete.id);
    await axios.delete(
      `${URL.api}activity/trail_allocation/partial_progression/delete/${trailToDelete.allocation_id}`,
      {
        headers: {
          authorization: `Bearer ${props.user.token}`
        }
      }
    );
    const updatedTrailList = trails.map(trail => {
      let auxTrail = trail;
      if (trail.id === trailToDelete.id) {
        auxTrail.allocation_id = 0;
      }
      return auxTrail;
    });
    setTrails(updatedTrailList);
    setTrailInAction(null);
    setShowModal(false);
  };

  return (
    <div>
      <CModal
        color="danger"
        show={showModal}
        centered
        onClose={() => setShowModal(false)}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>Apagar alocação</CModalHeader>
        <CModalBody>Deseja apagar a alocação?</CModalBody>
        <CModalFooter>
          <CButton color="danger" onClick={() => deleteAllocation()}>
            Confirmar
          </CButton>
          <CButton color="secondary" onClick={() => setShowModal(false)}>
            Cancelar
          </CButton>
        </CModalFooter>
      </CModal>
      <Breadcrumb current={props.currentRoute} />
      {loading ? (
        <Loading top="45" left="50" />
      ) : (
        <>
          <CCard className="p-4">
            <CRow className="w-100 justify-content-around align-items-center">
              <CCol md="6" sm="12">
                <SelectFilter
                  title="Séries"
                  icon="fa-institution"
                  placeholder="Selecione"
                  value={serie}
                  options={serieList}
                />
              </CCol>
              <CCol md="6" sm="12">
                <SelectFilter
                  title="Turma"
                  icon="fa-institution"
                  placeholder="Selecione"
                  value={serie}
                  options={classRoomList}
                />
              </CCol>
            </CRow>
          </CCard>
          <h3 className="mb-4">
            Aloque trilha de progressão parcial para
            <strong>Trail</strong>
          </h3>
          {/* {trails.length > 0 ? (
            <>
              {trails.map(trail => (
                <CCard accentColor="primary mt-0 mb-2" key={trail.id}>
                  <CCardHeader className="d-flex align-items-center rounded border-0">
                    <h4 className="m-0 p-0 flex-1 d-flex align-items-center">
                      {trail.name}
                      {trail.allocation_id !== 0 && (
                        <RiCheckDoubleFill className="ml-2 text-success" />
                      )}
                    </h4>
                    <CButton
                      color={trail.allocation_id ? "danger" : "primary"}
                      className="d-flex justify-content-center align-items-center ml-2"
                      disabled={trailInAction === trail.id}
                      onClick={async () => {
                        if (trail.allocation_id) {
                          setTrailToDelete(trail);
                          setShowModal(true);
                        } else {
                          setTrailInAction(trail.id);
                          createAllocation(trail.id);
                        }
                      }}
                    >
                      <>
                        <span
                          style={
                            trailInAction === trail.id ? { opacity: 0 } : null
                          }
                        >
                          {trail.allocation_id ? "Cancelar" : "Alocar"}
                        </span>
                        {trailInAction === trail.id && (
                          <CSpinner
                            size="sm"
                            color="white"
                            style={{ position: "absolute" }}
                          />
                        )}
                      </>
                    </CButton>
                  </CCardHeader>
                </CCard>
              ))}
            </>
          ) : (
            <div className="p-5 text-center text-muted w-100">
              Nenhuma trilha encontrada
            </div>
          )} */}
          <ProtectedRoute routeId={props.currentRoute} />
        </>
      )}
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

PartialProgressionAllocateByTrail.defaultProps = {
  hideLayout: false,
  guestLogin: true
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartialProgressionAllocateByTrail);
